function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import moment from 'moment';

/**
 * Convert times in TimePicker
 */
export var HOURS = [...Array(24).keys()];
export var get12Hour = time => {
  if (typeof time === 'string' && time === '') {
    return time;
  }

  if (time === undefined) {
    return undefined;
  }

  return moment(time, ['HH']).format('h:00 A');
};
export var getHourObj = () => {
  var hourItems = HOURS.map(hr => {
    var values = {
      value: hr,
      label: "" + get12Hour(hr)
    };
    return _extends({}, values);
  });
  return hourItems;
}; // for future iteration: keep values Date formatted
// export const getTimeLabel = (option: TimeShape): string => option.label
// export const getTimeValue = (option: TimeShape): TimeValueType => option.value
// export const findTime = (value: TimeValueType, options: Array<TimeShape>) => {
//   const option = options.find((option: TimeShape) => option.value === value)
//   return option || options[0]
// }
//# sourceMappingURL=utils.js.map